const base64UrlDecode = (input: string): string => {
  try {
    const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const decoded = atob(padded);
    // Handle UTF-8 characters
    const bytes = Uint8Array.from(decoded, (c) => c.charCodeAt(0));
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  } catch {
    return '';
  }
};

const decodeJwtPayload = <T = Record<string, unknown>>(token: string): T | null => {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const payloadJson = base64UrlDecode(parts[1]);
    return JSON.parse(payloadJson) as T;
  } catch {
    return null;
  }
};

export type AccessTokenClaims = {
  exp: number;
  sub: string;
  type: string;
  iat: number;
  jti?: string;
  role?: string;
  tenant_ids?: string[];
};

export const extractFirstTenantId = (token: string): string | null => {
  const claims = decodeJwtPayload<AccessTokenClaims>(token);
  const list = claims?.tenant_ids ?? [];
  return Array.isArray(list) && list.length > 0 ? list[0] : null;
};
